import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { Validations } from '../constants/validations.constant';

@Directive({
  selector: '[onlyNumberValidation]'
})
export class OnlyNumberValidationSchemaDirective {
  @Input() public allowDecimalValue!: boolean;
  @Input() public onlyNumberValidation!: boolean;

  constructor(private eleRef: ElementRef) { }

  @HostListener('keydown', ['$event']) onInputChange(event:any) {
    if(this.onlyNumberValidation){
      const charCode = (event.which) ? event.which : event.keyCode;
      if(this.allowDecimalValue && (charCode == 110 || (charCode == 190 && !event.shiftKey))) return true;
      if (charCode == 32 || charCode > 40 && (charCode < 48 || charCode > 57) && event.charCode != 46) event.preventDefault();
      const alphaNumericRegex = new RegExp(Validations.REGEX_ALPHANUMERIC_SPACES_HYPHEN_DOT);
      return alphaNumericRegex.test(event.key);
    }
    return true;
  }

}
